import { MessageCircle } from 'lucide-react'
import { DismissibleTooltip } from '../../../../common/DismissibleTooltip'
import {
  FeedbackSection,
  FeedbackRow,
  FeedbackContent,
  FeedbackLabel,
  FeedbackText,
  ChatButton,
} from '../styles/StakeholderRatingsFooterStyles'
import type { FeedbackItemProps } from '../types'

/**
 * A single feedback item (Concerns, Suggestions, or Would ask) with optional chat button
 */
export function FeedbackItem({
  label,
  content,
  tooltipText,
  accentColor,
  iconColor,
  onChat,
}: FeedbackItemProps): React.JSX.Element {
  return (
    <FeedbackSection>
      <FeedbackRow>
        <FeedbackContent>
          <FeedbackLabel>{label}</FeedbackLabel>
          <FeedbackText>{content}</FeedbackText>
        </FeedbackContent>
        {onChat && (
          <DismissibleTooltip title={tooltipText} placement="right" mouseEnterDelay={0.3}>
            <ChatButton
              $accentColor={accentColor}
              onClick={(e) => {
                e.stopPropagation()
                onChat()
              }}
            >
              <MessageCircle size={12} color={iconColor} />
            </ChatButton>
          </DismissibleTooltip>
        )}
      </FeedbackRow>
    </FeedbackSection>
  )
}
